import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import sticker from '@/components/sticker'

function renderSticker(h) {
  return h(
    sticker,
    {
      props: {
        value: this.file.filename,
        label: this.fileLabel,
        labelColor: this.labelColor,
        icon: icons.attach_file,
        color: Colors.grey,
        loading: this.fileLoading,
        button: {
          icon: icons.download,
          color: Colors.info,
          callback: () => {
            this.download()
          }
        }
      }
    }
  )
}
function renderButton(h) {
  let icon = icons.download
  let color = Colors.info

  if (this.buttonCallback) {
    icon = icons.done
    color = Colors.success
  }

  return h(
    button,
    {
      props: {
        icon,
        color,
        mode: buttonModes.flat,
        loading: this.fileLoading,
        disabled: this.fileLoading
      },
      on: {
        click: event => {
          this.download(event)
        }
      }
    }
  )
}

function renderInfo(h) {
  if (this.showInfo && this.fileNotFound) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate('file.errors.notFound'),
          color: Colors.error
        }
      }
    )
  }

  return h('div')
}

export default function(h) {
  if (this.file) {
    if (this.compact) {
      return renderButton.call(this, h)
    } else {
      return renderSticker.call(this, h)
    }
  } else {
    return renderInfo.call(this, h)
  }
}
